import { render } from "./latest-purchase.vue?vue&type=template&id=3dc55b0c&scoped=true"
import script from "./latest-purchase.vue?vue&type=script&lang=js"
export * from "./latest-purchase.vue?vue&type=script&lang=js"

import "./latest-purchase.vue?vue&type=style&index=0&id=3dc55b0c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc55b0c"]])

export default __exports__